module.exports = __webpack_public_path__ + "static/media/kws.46e51a53.png";